/* eslint-disable no-console */
const contentToggle = () => {
  const toggleContent = (btn) => {
    const ariaControls = btn.getAttribute('aria-controls');
    const ariaExpanded = btn.getAttribute('aria-expanded');
    const closedLabel = btn.getAttribute('data-closedlabel');
    const content = document.getElementById(ariaControls);
    const openLabel = btn.getAttribute('data-openlabel');

    if (ariaExpanded === 'false') {
      btn.setAttribute('aria-expanded', 'true');
      btn.innerHTML = openLabel;
      content.classList.remove('hidden');
    } else {
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = closedLabel;
      content.classList.add('hidden');
    }
  };

  const contentToggleBtns = document.querySelectorAll('.content-toggle-btn');
  [].map.call(contentToggleBtns, btn => btn.addEventListener('click', () => {
    toggleContent(btn);
  }));
};

export default contentToggle;
/* eslint-enable no-console */
